<script>
    import { currency_formatter } from '../../globals';
    import { querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import Modal from '../elements/Modal.svelte';
    import breakpoints from "../../utils/breakpoints";
    import { push } from 'svelte-spa-router';
    import GoogleMap from "../../utils/GoogleMap.svelte";
    import { api_host, price_setting_store, all_users_store, user_store, company_details_store } from "../../stores.js";
    import { init_data } from '../../init.js';
    import Loading from '../loading.svelte';
    import { getToken, doFetch } from "../../utils/Fetching.js";
    import { toast_message } from '../../utils/toast_message.js';
    import { formatPhoneNumber, formatDateAndTime, jobStatsToNum, getFullState, formatDate, handle_not_subscribed, deepCopy } from '../../utils/format.js';
    import { getTax, renderExtraContractorPriceTable, renderMainServicePriceTable, renderExtraServicePriceTable, getSubtotal, getTotalTax, isNewLayout, get_extra_service_prices } from '../../utils/tax.js';
    import Clipboard from "svelte-clipboard";
    import Swal from "sweetalert2";
    import IFTAInput from "../../utils/iftainput.svelte";

    
    const { auth_type, auth_token, domain_code } = getToken();

    const bp = breakpoints();

    let content_title = "Job Review";
    let job = {};
    let all_crews = [];
    let not_assigned_crews = [];
    let jid = "";
    let is_busy = false;
    let price_setting = {};
    let is_loaded = false;
    let payment_status = true;
    let myself = {};

    // photo popup modal
    let modal_photo_popup = false;
    let selected_photo = null;

    user_store.subscribe(value => {
        myself = value;
        if (myself.plan_type === 'basic') {
            content_title = 'Request Review';
        }
    });

    price_setting_store.subscribe(value => {
        price_setting = value;
    });

    $: is_employee_exists = (job.crew_users || []).filter(item => item.role === 'employee' || item.role === 'landscaper').length > 0;

    const refresh_job = async (jid) => {
        const res = await doFetch(
            `${api_host}/api/job/get/${jid}`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            job = res.job;
            if (job.status === 'unpaid') {
                payment_status = false;
            }
            if (job.crew_users) {
                const assigned_crew_ids = job.crew_users.map(crew => crew.id);
                all_users_store.subscribe(value => {
                    all_crews = value.filter(user => (user.role === 'contractor' || user.role === 'employee' || user.role === 'landscaper') && user.is_active);
                    const _not_assigned_crews = [];
                    for (let i = 0; i < all_crews.length; i ++) {
                        const _crew = all_crews[i];
                        if (!assigned_crew_ids.includes(_crew.id)) {
                            _not_assigned_crews.push({
                                id: _crew.id,
                                role: _crew.role,
                                first_name: _crew.first_name,
                                last_name: _crew.last_name
                            });
                        }
                    }
                    not_assigned_crews = _not_assigned_crews;
                });
            }
        } else {
            if (res.msg === 'Job not found') {
                const redirect_url = btoa('#/Jobs?filter=all');
                push(`#/RedirectTo?redirect_url=${redirect_url}`);
            }
            toast_message(false, res.msg || 'Fetching job details failed', 3000);
        }
        is_loaded = true;
    }

    onMount(async () => {
        const params = new URLSearchParams($querystring);

        if (params.has("jid")) {
            jid = params.get("jid");
            refresh_job(jid);
        }
    });

    const updateStatusAction = async (action_id) => {
        is_busy = true;

        if (action_id === 'invoice') {
            if (job.invoice.invoice_number) {
                push(`#/Invoice_Review?iid=${job.invoice.invoice_number}`);
            } else {
                toast_message('Invoice unavailable');
            }
            return;
        }

        const res = await doFetch(
            `${api_host}/api/job/update/status`,
            'POST',
            { job_id: jid, action: action_id, payment_status },
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            job.status = res.updated_status;
            if (job.status === 'assigned') { job.picked_at = formatDateAndTime(res.updated_date); }
            else if (job.status === 'completed') { job.completed_at = formatDateAndTime(res.updated_date); }
            else if (job.status === 'approved') { job.approved_at = formatDateAndTime(res.updated_date); }
            else if (job.status === 'invoiced') { job.invoiced_at = formatDateAndTime(res.updated_date); }
            else if (job.status === 'charged') { job.charged_at = formatDateAndTime(res.updated_date); }
            if (res.msg.includes('card declined')) {
                res.msg = `${job.profile.first_name} ${job.profile.last_name}, card declined`;
            }
            toast_message(res.action_status, res.msg, 3000);
            refresh_job(jid);
            init_data('jobs');
        } else {
            toast_message(false, res.msg || 'Failed updating job status', 3000);
        }
        is_busy = false;
    }

    const updateStatus = async () => {
        const { action_id, action_code } = getNextStatus(job.status);
        if (action_id === 'charge' || action_id === 'complete' || action_id === 'approve') {
            if (!job.crew_users) job.crew_users = [];
            if (job.crew_users.length === 0) {
                toast_message(false, 'Assign a crew', 3000);
                return;
            }
            is_busy = true;
            let title = '';
            if (action_id === 'charge') {
                title = action_code === 'Close Job' ? ('Close Job?') : (action_code === 'Charge Client' ? 'Charge Client?' : 'Update Job?');
            } else if (action_id === 'complete') {
                title = 'Mark Complete?';
            } else {
                title = 'Approve Job?';
            }
            Swal.fire({
                title: title,
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'OK',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "success"
            }).then(async (e) => {
                if (e.isConfirmed) {
                    await updateStatusAction(action_id);
                }
            });
        } else {
            await updateStatusAction(action_id);
        }

        is_busy = false;
    }

    const sendReminder = async () =>{
        is_busy = true;
        const res = await doFetch(
            `${api_host}/api/job/reminder_email`,
            'POST',
            { job_id: jid },
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            toast_message(true, res.msg, 3000);
        } else {
            toast_message(false, res.msg || 'Failed sending email', 3000);
        }
        is_busy = false;
    }

    const getNextStatus = (status) => {
        if (status === 'pending') {
            return {
                action_code: 'Post Job',
                action_id: 'post'
            };
        } else if (status === 'assigned' || status === 'not_assigned') {
            return {
                action_code: 'Mark Complete',
                action_id: 'complete'
            };
        } else if (status === 'completed') {
            return {
                action_code: 'Approve Job',
                action_id: 'approve'
            };
        } else if (status === 'approved') {
            if (job.paymethod !== 'Credit Card') {
                return {
                    action_code: 'Close Job',
                    action_id: 'charge'
                };
            }
            return {
                action_code: 'Charge Client',
                action_id: 'charge'
            };
        } else if (status === 'refunded') {
            if (job.paymethod !== 'Credit Card') {
                return {
                    action_code: 'Close Job',
                    action_id: 'charge'
                };
            }
            return {
                action_code: 'Charge Client',
                action_id: 'charge'
            };
        } else if (status === 'charged') {
            return {
                action_code: 'Invoice',
                action_id: 'invoice'
            };
        } else if (status === 'unpaid') {
            if (job.paymethod === 'Credit Card') {
                return {
                    action_code: 'Charge Client',
                    action_id: 'charge'
                };
            } else {
                return {
                    action_code: 'Update Job',
                    action_id: 'charge'
                };
            }
        } else if (status === 'card_declined') {
            if (job.paymethod !== 'Credit Card') {
                return {
                    action_code: 'Close Job',
                    action_id: 'charge'
                };
            }
            return {
                action_code: 'Charge Client',
                action_id: 'charge'
            };
        } else {
            return {
                action_code: 'Invoice',
                action_id: 'invoice'
            };
        }
    }

    let update_payment_status = (evt) => {
        if (evt.target.value === 'Payment received') payment_status = true;
        else payment_status = false;
    }

    const refund = async (job_id) => {
        Swal.fire({
            title: 'Refund this job?',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'OK',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "warning"
        }).then(async (e) => {
            if (e.isConfirmed) {
                is_busy = true;
                const res = await doFetch(
                    `${api_host}/api/job/refund`,
                    'POST',
                    { jid: job_id },
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                if (res.status) {
                    job.status = res.updated_status;
                    toast_message(true, res.msg, 3000);
                    refresh_job(jid);
                    init_data('jobs');
                } else {
                    toast_message(false, res.msg || 'Refund failed', 3000);
                }
                is_busy = false;
            }
        });
    }
    
    const pre_processing = () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return false;
        } else {
            return true;
        }
    }

    const numFormatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 6
    });

    const showThumbnail = (photo) => {
        selected_photo = photo;
        modal_photo_popup = true;
    }

</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

{#if is_loaded && Object.keys(job).length > 0}
<div class="contentholder">
    {#if myself.plan_type !== 'basic'}
    <div class="buttonholder">
        {#if job.status === 'pending'}
            <button class="action" style='background-color: #d9534f;' on:click={() => { if (pre_processing()) { updateStatus(); } }} disabled={is_busy}>
                <i class="far fa-check-circle"></i>&nbsp;
                Post Job
            </button>
        {/if}
        {#if jobStatsToNum(job.status || '')[0] <= 5}
            <button class="edit" on:click={() => { if (pre_processing()) { push("#/Job_Edit?jid=" + jid); } }} >
                <i class="fas fa-edit"></i> Edit Job
            </button>
        {/if}
        {#if getNextStatus(job.status || '').action_code === 'Close Job' || getNextStatus(job.status || '').action_code === 'Update Job'}
            <div style='width: 300px;height: 95px;'>
                <IFTAInput
                    type='select'
                    label='Payment Status'
                    placeholder='Select payment status'
                    select_options={['Payment received', 'Payment not received']}
                    name='jobreview[payment_method]'
                    value={job.status === 'unpaid' ? 'Payment not received' : 'Payment received'}
                    bind:change_function={update_payment_status}
                />      
            </div>
        {/if}
        {#if job.status === 'charged' && job.paymethod !== 'Credit Card'}
            <span style='padding-top: 10px;padding-right: 10px;'><b><i>Payment received</i></b></span>
        {/if}
        {#if (job.status === 'unpaid' || job.status === 'refunded' || job.status === 'card_declined' || job.status === 'approved') && job.invoice.invoice_number}
            <button class="action" on:click={() => { if (pre_processing()) { push(`#/Invoice_Review?iid=${job.invoice.invoice_number}`); } }} disabled={is_busy} style='background-color: #ff9100;'>
                <i class={`far fa-file-invoice-dollar`}></i>&nbsp;Invoice
            </button>
        {/if}
        {#if job.status !== 'pending'}
            <button class={`action ${(job.status === 'unpaid' && payment_status === false && job.paymethod !== 'Credit Card') ? 'disable_btn' : ''}`} on:click={() => { if (pre_processing()) { updateStatus(); } }} disabled={is_busy}>
                <i class={`far ${job.status === 'charged' ? 'fa-file-invoice-dollar' : 'fa-check-circle'}`}></i>&nbsp;
                {getNextStatus(job.status || '').action_code}
            </button>
        {/if}
        {#if job.status === 'charged' && job.paymethod === 'Credit Card'}
            <button class="action" on:click={() => { if (pre_processing()) { refund(job.id); } }} disabled={is_busy} style='background-color: #ff9100;'>
                <i class={`far fa-undo`}></i>&nbsp;Refund
            </button>
        {/if}
        {#if jobStatsToNum(job.status || '')[0] < 3 && job.status !== 'pending'}
            <button class="reminder" disabled={is_busy} on:click={() => { if (pre_processing()) { sendReminder(); } }}>
                <i class="far fa-clock"></i> Send Reminder
            </button>
        {/if}
    </div>
    {/if}
    
    {#if myself.plan_type !== 'basic'}
    <div class="section progress" style="display: inline-table;padding-bottom: 5px;">
        <div class="sectiontitle"><i class="fas fa-stream"></i> Progress</div>
        <div class="progressholder">
            <div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 0 ? ' completed' : '')}>
                <div class="progressiteminfo">1) Created</div>
                <div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 0 ? 'Done' : 'In Progress'}</div>
                <div class="progressitemts">{jobStatsToNum(job.status)[0] >= 1 ? formatDateAndTime(job.created_at) : ''}</div>
            </div>
            <div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

            <div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 2 ? ' completed' : '')}>
                <div class="progressiteminfo">2) Crew assigned:</div>
                <div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 2 ? 'Done' : 'In Progress'}</div>
                <div class="progressitemts">{jobStatsToNum(job.status)[0] >= 2 ? formatDateAndTime(job.picked_at) : ''}</div>
            </div>
            <div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

            <div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 3 ? ' completed' : '')}>
                <div class="progressiteminfo">3) Crew completed:</div>
                <div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 3 ? 'Done' : 'In Progress'}</div>
                <div class="progressitemts">{jobStatsToNum(job.status)[0] >= 3 ? formatDateAndTime(job.completed_at) : ''}</div>
            </div>
            <div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

            <div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 4 ? ' completed' : '')}>
                <div class="progressiteminfo">4) Work approved:</div>
                <div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 4 ? 'Done' : 'In Progress'}</div>
                <div class="progressitemts">{jobStatsToNum(job.status)[0] >= 4 ? formatDateAndTime(job.approved_at) : ''}</div>
            </div>
            <div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

            <!-- {#if !is_employee_exists}
            <div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 5 ? ' completed' : '')}>
                <div class="progressiteminfo">5) Crew invoiced:</div>
                <div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 5 ? 'Done' : (job.status === 'unpaid' ? 'Open' : 'In Progress')}</div>
                <div class="progressitemts">{jobStatsToNum(job.status)[0] >= 5 ? formatDateAndTime(job.charged_at) : ''}</div>
            </div>
            <div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>
            {/if} -->

            <div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 6 ? ' completed' : '')}>
                <div class="progressiteminfo">5) Client charged:</div>
                <div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 6 ? 'Done' : (jobStatsToNum(job.status)[0] >= 4 ? jobStatsToNum(job.status)[1] : 'In Progress')}</div>
                <div class="progressitemts">{jobStatsToNum(job.status)[0] >= 6 ? formatDateAndTime(job.charged_at) : ''}</div>
            </div>
        </div>
    </div>
    {/if}
    
    <div class="section pricinginfo">
        <div class="sectiontitle"><i class="fas fa-dollar-sign"></i> Pricing Information</div>

        <div class="sectioninfo">
            <div class="leftcolumn">
                <div class="infoitem">
                    <div class="infoitemtitle">Client Margin:</div>
                    <div class="infoitemvalue">{parseFloat(price_setting['client_margin'] || 0).toFixed(2)}</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Contractor Margin:</div>
                    <div class="infoitemvalue">{is_employee_exists ? '-' : numFormatter.format(parseFloat(job.contractor_margin))}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Contractor Price:</div>
                    <div class="infoitemvalue">{is_employee_exists ? '-' : currency_formatter.format(parseFloat(job.contractor_price))}</div>
                </div>
                {#if !is_employee_exists && isNewLayout(job)}
                <div class="infoitem">
                    <div class="infoitemtitle">Extra Contractor Price:</div>
                    {#if job.extra_contractor_prices.length == 0 }
                    <div class="infoitemvalue">$0.00</div>
                    {/if}
                </div>
                <div class="infoitem service-price">
                    {@html renderExtraContractorPriceTable(job.extra_contractor_prices)}
                </div>
                {:else}
                <div class="infoitem">
                    <div class="infoitemtitle">Extra Contractor Price:</div>
                    <div class="infoitemvalue">{is_employee_exists ? '-' : currency_formatter.format(parseFloat(job.extra_contractor_price))}</div>
                </div>
                {/if}
                <div class="infoitem">
                    <div class="infoitemtitle">Total Contractor Price:</div>
                    <div class="infoitemvalue"><b>{is_employee_exists ? '-' : currency_formatter.format(parseFloat(job.total_contractor_price))}</b></div>
                </div>                
                <div class="infoitem">
                    <div class="infoitemtitle">Payment Method:</div>
                    <div class="infoitemvalue">
                        {job.paymethod}
                        {#if job.paymethod === 'Credit Card' && !job.paycard}
                            <span style="color: red;">(Card info needed)</span>
                        {/if}
                    </div>
                </div>
                {#if job.total_service_price !== job.original_service_price && job.original_service_price !== 0}
                    <div class="infoitem">
                        <div class="infoitemtitle">Original Service Price:</div>
                        <div class="infoitemvalue">
                            <b><s>{currency_formatter.format(parseFloat(job.original_service_price))}</s></b>
                        </div>
                    </div>
                    {#if job.coupon.id}
                        <div class="infoitem">
                            <div class="infoitemtitle">Coupon Code:</div>
                            <div class="infoitemvalue">
                                {job.coupon.code}
                            </div>
                        </div>
                    {/if}
                {/if}
                {#if isNewLayout(job)}
                <div class="infoitem">
                    <div class="infoitemtitle">Service Price:</div>
                </div>
                <div class="infoitem service-price">
                    {@html renderMainServicePriceTable(job.service_prices)}
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Extra Service Price:</div>
                    {#if get_extra_service_prices(job.service_prices).length == 0 }
                    <div class="infoitemvalue">$0.00</div>
                    {/if}
                </div>
                <div class="infoitem service-price">
                    {@html renderExtraServicePriceTable(job.service_prices)}
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Subtotal:</div>
                    <div class="infoitemvalue">{currency_formatter.format(getSubtotal(job.service_prices))}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Tax:</div>
                    <div class="infoitemvalue">{currency_formatter.format(getTotalTax(job.service_prices))}</div>
                </div>
                {:else}
                <div class="infoitem">
                    <div class="infoitemtitle">Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(job.service_price)}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Extra Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(job.extra_service_price)}</div>
                </div>
                {/if}
                <div class="infoitem">
                    <div class="infoitemtitle">Total Service Price:</div>
                    <div class="infoitemvalue"><b>{currency_formatter.format(job.total_service_price)}</b></div>
                </div>
                {#if job.service_frequency !== 'One-Time'}
                <div class="infoitem">
                    <div class="infoitemtitle">Next Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(parseFloat(job.next_service_price))}</div>
                </div>
                {/if}
            </div>
        </div>
    </div>

    <div class="section clientinfo">
        <div class="sectiontitle"><i class="fas fa-user"></i> Client Information</div>

        <div class="sectioninfo">
            <div class="leftcolumn">
                <div class="infoitem">
                    <div class="infoitemtitle">Name:</div>
                    <div class="infoitemvalue"><a href={`#/User_Review?uid=${job.uid}`}>{job.profile ? `${job.profile.first_name} ${job.profile.last_name}` : ''}</a></div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Address:</div>
                    <div class="infoitemvalue">
                        {job.profile ? `${job.profile.address}, ${job.profile.city}, ${getFullState(job.profile.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}` : ''}
                        &nbsp;
                        <Clipboard
                            text={job.profile ? `${job.profile.address}, ${job.profile.city}, ${getFullState(job.profile.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}` : ''}
                            let:copy
                            on:copy={() => { toast_message(true, 'Address Copied', 1000); }}
                        >
                            <i class="fas fa-copy" style="color: #555555;cursor: pointer;" on:click={copy}></i>
                        </Clipboard>
                    </div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Email:</div>
                    <div class="infoitemvalue">{job.profile.email}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Secondary Emails:</div>
                    <div class="infoitemvalue">
                        <div style="display: flex; flex-direction: column;">
                            {#each (job.profile.emails ?? []) as email}
                            <span>{email}</span>
                            {/each}
                        </div>
                    </div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Home Phone:</div>
                    <div class="infoitemvalue">{(job.profile && job.profile.home_phone) ? formatPhoneNumber(job.profile.home_phone) : ''}</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Cell Phone:</div>
                    <div class="infoitemvalue">{(job.profile && job.profile.mobile_phone) ? formatPhoneNumber(job.profile.mobile_phone) : ''}</div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="section serviceinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>

        <div class="sectioninfo">
            <div class="leftcolumn">
                <div class="infoitem">
                    <div class="infoitemtitle">Service Date:</div>
                    <div class="infoitemvalue">{formatDate(job.service_date)} - {job.time_preference === 'No Preference' ? 'Time (No Preference)' : job.time_preference}</div>
                </div>

                {#if job.service_frequency !== 'One-Time'}
                <div class="infoitem">
                    <div class="infoitemtitle">Next Service Date:</div>
                    <div class="infoitemvalue">{formatDate(job.next_service_date)} - {job.time_preference === 'No Preference' ? 'Time (No Preference)' : job.time_preference}</div>
                </div>
                {/if}
            
                <div class="infoitem">
                    <div class="infoitemtitle">Address:</div>
                    <div class="infoitemvalue">
                        {`${job.address}, ${job.city}, ${getFullState(job.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}`}
                        &nbsp;
                        <Clipboard
                            text={`${job.address}, ${job.city}, ${getFullState(job.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}`}
                            let:copy
                            on:copy={() => { toast_message(true, 'Address Copied', 1000); }}
                        >
                            <i class="fas fa-copy" style="color: #555555;cursor: pointer;" on:click={copy}></i>
                        </Clipboard>
                    </div>
                </div>

                <!-- <div class="infoitem">
                    <div class="infoitemtitle">Lot Size:</div>
                    <div class="infoitemvalue">{job.lot_size ? new Intl.NumberFormat().format(parseInt(job.lot_size)) :  '-'} sq ft</div>
                </div> -->
            </div>

            <div class='rightcolumn'>
                <div class="infoitem">
                    <div class="infoitemtitle">Lawn:</div>
                    <div class="infoitemvalue">{job.lawn}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Last Time Clean Up (days):</div>
                    <div class="infoitemvalue">{job.last_service}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Service Type:</div>
                    <div class="infoitemvalue">{job.service_type}</div>
                </div>
                
                <div class="infoitem">
                    <div class="infoitemtitle">Service Frequency:</div>
                    <div class="infoitemvalue">{job.service_frequency}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Back Yard Entry Instruction:</div>
                    <div class="infoitemvalue">{job.back_yard_entry}</div>
                </div>
            </div>
        </div>
        
    </div>

    <div class="section contractors">
        <div class="sectiontitle">Crew Assigned</div>
        <div class="sectioninfo">
            <div class="leftcolumn">
                {#if job.crew_users}
                    {#each job.crew_users as crew_user, i}
                        <div>
                            <i class='fas fa-check' style='color: darkslategray;'></i>
                            <a href={`#/User_Review?uid=${crew_user.id}`}>
                                {`${crew_user.first_name} ${crew_user.last_name}` + (crew_user.role === 'landscaper' ? ' (Owner)' : '')}
                            </a>
                        </div>
                    {/each}
                {/if}
                {#each not_assigned_crews as not_assigned_crew, i}
                    <div>
                        <a href={`#/User_Review?uid=${not_assigned_crew.id}`}>
                            {`${not_assigned_crew.first_name} ${not_assigned_crew.last_name}` + (not_assigned_crew.role === 'landscaper' ? ' (Owner)' : '')}
                        </a>
                    </div>
                {/each}
            </div>
        </div>
    </div>

    <!-- <div class="section map">
        <div class="sectiontitle">Map</div>
        <div class="mapholder">
            <GoogleMap
                address={job.address}
                city={job.city}
                state={job.state}
            />    
        </div>
    </div> -->

    {#if is_employee_exists}
    <div class="section timesheetinfo">
        <div class="sectiontitle"><i class="fal fa-user-hard-hat"></i> Timesheet</div>
        <div class="sectioninfo">
            <table>
                <tr>
                    <th>Crew name</th>
                    <th>Hours</th>
                    <th>Notes</th>
                </tr>
                {#each job.crew_users.filter(it => it.role !== 'contractor') as item}
                <tr>
                    <td>{ item.first_name } { item.last_name }</td>
                    <td>{ item.hours }</td>
                    <td>{ item.notes }</td>
                </tr>
                {/each}
            </table>
        </div>
    </div>
    {/if}

    <div class="section additionalcomments">
        <div class="sectiontitle">Additional Comments</div>
        <div class="sectioninfo"><pre style="white-space: pre-wrap; word-break: auto-phrase;">{job.additional_comments || 'None'}</pre></div>
    </div>
    <div class="section internalcomments">
        <div class="sectiontitle">Internal Comments</div>
        <pre  style="white-space: pre-wrap; word-break: auto-phrase;">{job.internal_comments || 'None'}</pre>    
    </div>

    {#if (job.photos ?? []).length > 0}
    <div class="section photoinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
        <div class="sectioninfo">
            <div class="photo-list">
                {#each (job.photos ?? []) as photo}
                <div class="photo-item">
                    <img class="photo" src="{photo}" alt="{photo}"  on:click="{showThumbnail(photo)}" />
                </div>
                {/each}
            </div>
        </div>
    </div>
    {/if}

    <Modal bind:modal_show={modal_photo_popup} modal_width={window.innerWidth < 600 ? window.innerWidth - 10 : 600} modal_padding=15>
        <div>
            <div style="padding-bottom: 5px; font-size: 18px; font-weight: 500;">Photo</div>
            <img class="photo-thumbnail" src="{selected_photo}" alt="{selected_photo}" />
        </div>
    </Modal>
</div>
{:else}
<Loading />
{/if}

<style>
    .disable_btn {
        opacity: 0.8;
        pointer-events: none;
        cursor: not-allowed;
    }
    .strikeout {
        text-decoration: line-through;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
                             "si si si si si si si si si si si si"
                             "ci ci ci ci ci ci pi pi pi pi pi pi"
                             "ac ac ac ac ac ac ic ic ic ic ic ic"
                             "cr cr cr cr cr cr ma ma ma ma ma ma"
                             "ts ts ts ts ts ts ts ts ts ts ts ts"
                             "pr pr pr pr pr pr pr pr pr pr pr pr"
                             "py py py py py py py py py py py py";
        gap: 20px;

    }
    .buttonholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        grid-area: bh;
        align-items: center;
    }
    .buttonholder button {
        width: 150px;
        margin-right: 5px;
        margin-top: 10px;
        font-size: 12px;
    }
    .buttonholder button.edit{
        background-color: #1c54b2;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        width: auto;
    }
    .buttonholder button.action{
        background-color: #357a38;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        width: auto;
    }
    .buttonholder button.reminder{
        background-color: #ff9100;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        width: auto;
    }
    .progress {
        grid-area: pr;
    }
    .progressholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 50%;
        font-weight: bold;
        text-align: left;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        width: 50%;
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .pricinginfo .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }
    .pricinginfo .leftcolumn{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .serviceinfo .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }
    .serviceinfo .leftcolumn {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .serviceinfo .rightcolumn{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .progressitem {
        font-size: 10px;
        width: 150px;
        height: 64px;
        background-color: #ffea00;
        border: 1px solid black;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        margin-top: 5px;
    }
    :global(.progressitem.completed) {
        background-color: #a2cf6e !important;
    }
    :global(.progressitem.completed .progressitemts) {
        color: white !important;
    }
    .progressiteminfo{
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .progressitemstatus{
        width: 100%;
        font-weight: bold;
        
    }
    .progressitemts {
        width: 100%;
        color: #999;
        font-style: italic;
    }
    .progressflowarrow {
        font-size: 40px;
        font-weight: bold;
        color: #666;
        height: 50px;
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .pricinginfo {
        grid-area: pi;
    }
    .clientinfo {
        grid-area: ci;
    }
    .serviceinfo {
        grid-area: si;
    }
    .timesheetinfo {
        grid-area: ts;
    }
    .timesheetinfo table th, .timesheetinfo table td {
        padding: 4px 5px;
        border: 1px solid grey;
    }
    .photoinfo {
        grid-area: py;
    }
    .contractors {
        grid-area: cr;
    }
    .map {
        grid-area: ma;
        width: 100%;
        height: 300px;
    }
    .additionalcomments {
        grid-area: ac;
    }
    .internalcomments {
        grid-area: ic;
    }
    .section {
        border: 1px solid #1769aa;
    }
    .photo-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .photo-item {
        display: flex;
        flex-direction: column;
        margin: 10px;
    }
	.photo{
		height: 150px;
		width: 150px;
	}
    .photo-thumbnail {
        height: 100%;
        width: 100%;
        max-height: 600px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "bh"
                                "si"
                                "pi"
                                "ci"
                                "ac"
                                "ic"
                                "cr"
                                "ma"
                                "ts"
                                "pr"
                                "py";
            gap: 20px;
        }
        .photoinfo {
            grid-area: py;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button.edit { width: 100%; }
        .buttonholder button.action { width: 100%; }
        .buttonholder button.reminder { width: 100%; }
        .progressholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .progressitem {
            width: 100%;
            height: 25px;
            padding: 0px;
            background-color: #ffea00;
            border: 1px solid black;
            display: flex;
            flex-direction: row;
            text-align: left;
            align-items: center;
            margin-top: 5px;
            border-radius: 0px;
        }
        .progressitemts {
            text-align: right;
        }
        .progressflowarrow {
            font-size: 12px;
            font-weight: bold;
            color: #666;
            height: 12px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .infoitem {
            width: 100%;
            display: flex;
            flex-direction: row;
        }
        .infoitem .infoitemtitle {
            width: 50%;
            font-weight: bold;
            text-align: left !important;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .infoitem .infoitemvalue {
            text-align: left;
            margin-left: 10px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
            width: 50%;
        }
        .pricinginfo .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .pricinginfo .leftcolumn{
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .serviceinfo .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .serviceinfo .leftcolumn {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .serviceinfo .rightcolumn{
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    }
</style>